export default {
  respurchase_report: "تقرير المشتريات",
  resloading_purchase_report: "جاري تحميل تقرير المشتريات...",

  restotal_purchase: "إجمالي المشتريات",
  restotal_orders: "إجمالي الطلبات",
  restotal_quantity: "إجمالي الكمية",
  ressuppliers: "الموردون",

  ressearch_purchase: "ابحث بالطلب / المنتج / المورد...",
  resall_status: "كل الحالات",
  resall_suppliers: "كل الموردين",

  resdelivered: "تم التسليم",
  respending: "قيد الانتظار",
  rescancelled: "ملغي",

  resorder_id: "رقم الطلب",
  resdate: "التاريخ",
  ressupplier: "المورد",
  resproduct: "المنتج",
  resqty: "الكمية",
  resamount: "المبلغ",
  resstatus: "الحالة",

  resno_data_found: "لا توجد بيانات",

  resprev: "السابق",
  resnext: "التالي",
  respage: "الصفحة",
  resof: "من",
  "resorder_id": "رقم الطلب",
  "resorder_date": "تاريخ الطلب",
  "resexpected_delivery": "تاريخ التسليم المتوقع",
  "ressupplier": "المورد",
  "resstatus": "الحالة",
  "respayment_status": "حالة الدفع",
  "respayment_method": "طريقة الدفع",

  "resitems": "العناصر",
  "resproduct": "المنتج",
  "resqty": "الكمية",
  "resprice": "السعر",
  "resdiscount": "الخصم",
  "resamount": "المبلغ",

  "restotal": "الإجمالي",
  "respaid": "المدفوع",
  "resdue": "المتبقي",

  "resremarks": "ملاحظات",
  "resclose": "إغلاق",

  "resdownload_excel": "تحميل إكسل",
  "resdownload_pdf": "تحميل PDF",

  "resaction": "إجراء",
  "resview": "عرض",

  "resno_data_found": "لا توجد بيانات",
  "resno_recent_orders": "لا توجد طلبات حديثة",

  "resitems_count": "عدد العناصر",
  "resorder_summary": "ملخص الطلب",
  "confirmed":"مؤكد",
};